import { useTexts } from 'utils/useTexts';
import Footer from '@components/shared/Footer/Footer';
import CurrentAddressInfoForm from '@components/CurrentAddressInfoForm/CurrentAddressInfoForm';

const CurrentAddressInfo = () => {
  const { t } = useTexts();
  return (
    <>
      <CurrentAddressInfoForm />

      <Footer text={t('enterLicensePlate.footer.footerText')} />
    </>
  );
};

export default CurrentAddressInfo;
